import { createFileRoute } from '@tanstack/react-router'
import { CompanySettings } from '@/features/settings/company-settings'

export const Route = createFileRoute('/_layout/_app/settings/company')({
  component: CompanySettings,
})
